import { render, staticRenderFns } from "./TablesUser.vue?vue&type=template&id=63797ed0"
import script from "./TablesUser.vue?vue&type=script&lang=js"
export * from "./TablesUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports